import { Filter } from '../typings/filters'
import { NextRouter } from 'next/router'

const hasFiltersExist = (router: NextRouter): Boolean => {
  if (router === undefined || router.query === undefined) return false
  return router.query?.filters !== undefined && router.query?.filters !== ''
}

export const getFilters = (router: NextRouter): Filter[] | [] => {
  const hasFilters = hasFiltersExist(router)
  if (!hasFilters) return []
  return JSON.parse(router.query.filters as string)
}
export const isProductConditionFiltered = (router?: NextRouter): boolean => {
  return getProductConditionsFiltered(router).length > 0
}

export const getProductConditionsFiltered = (
  router?: NextRouter
): string[] | [] => {
  const filters = getFilters(router)
  if (filters.length === 0) return []
  const productConditions = filters.find(
    (filter: Filter) => filter?.code === 'productCondition'
  )
  if (productConditions === undefined) return []
  return productConditions.values
}

export const getLowestConditionByConditions = (conditions): string => {
  if (conditions.includes('goodCondition')) return 'goodCondition'
  if (conditions.includes('veryGoodCondition')) return 'veryGoodCondition'
  if (conditions.includes('perfectCondition')) return 'perfectCondition'
}

export const isProductSizesFiltered = (router: NextRouter): boolean => {
  return getProductSizesFiltered(router).length > 0
}

export const getProductSizesFiltered = (router: NextRouter): string[] | [] => {
  if (router === undefined) return []
  const filters = getFilters(router)
  if (filters.length === 0) return []
  const productSizes = filters.find((filter: Filter) => filter.code === 'size')
  if (productSizes === undefined) return []
  return productSizes.values
}
